// @flow

import React, { Component } from 'react';
import type { Props } from 'react';
// import { HashRouter as Router } from 'react-router-dom';
import { clientEnhance, getDeviceType, RouteRenderer } from '@fil-global/eiswagen';
import { Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import { debounce, get } from 'lodash';
import RiskMinder from '@fil-global/fil-lib-riskminder';
// Global Import
import { onDeviceResize } from './global/actions';
// Style Import
import './styles/styles.scss';
import { logOut, handleSessionLogout } from './containers/organisms/Header/Header.actions';
import { fetchLabelsAction } from './global/actions';
// Routes Import
import routeConfig from './routes';
import { DASHBOARD, RE_DASHBOARD, FUND_DASHBOARD, IDLE_TIMEOUT } from './global/constants';

let time: any = 0;
export const inactivityTime = function (
  history,
  handleSessionLogoutDispatcher
) {
  window.onload = resetTimer;
  document.onload = resetTimer;
  document.addEventListener('mousemove', resetTimer);
  document.addEventListener('keypress', resetTimer);
  document.addEventListener('onmousedown', resetTimer);
  document.onmousemove = resetTimer;
  document.onmousedown = resetTimer; // touchscreen presses
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer; // touchpad clicks
  document.onkeypress = resetTimer; // keypress
  document.addEventListener('scroll', resetTimer, true);

  async function logout() {
    sessionStorage.setItem('sessionTimeOutCode',401);
    await handleSessionLogoutDispatcher();
    history.push('/sessiontimeout');
  }
  function resetTimer() {
    clearTimeout(time);
    time = setTimeout(logout, IDLE_TIMEOUT);
  }
};
class App extends Component<Props> {

  setDeviceConfig = debounce(() => {
    const { deviceType, onDeviceResizeAction } = this.props;

    const currentDeviceType = getDeviceType();

    if (deviceType && currentDeviceType !== deviceType) {
      onDeviceResizeAction({ deviceType: currentDeviceType });
    }
  }, 250);

  historyListner = null;

  constructor(props) {
    super(props);
    const { history,handleSessionLogoutDispatcher, logOutDispatcher, fetchLabelDispatcher} = this.props;
    let clickedItem = '';

    document.body.addEventListener('click', e => {
      clickedItem = e.target.nodeName;
    });



inactivityTime(history, handleSessionLogoutDispatcher);

    this.historyListner = props.history.listen(() => {
      let val = true;
      if (history.action === 'POP') {
        if (
          history.location.pathname !== '/userprereg' &&
          history.location.pathname !== '/sessiontimeout' &&
          history.location.pathname !== '/verifyemail' &&
          history.location.pathname !== '/ca' &&
          history.location.pathname !== '/login' &&
          history.location.pathname !== '/unregisteruserlist' &&
          history.location.pathname !== '/' + DASHBOARD &&
          history.location.pathname !== '/' + RE_DASHBOARD &&
          history.location.pathname !== '/' + FUND_DASHBOARD
        ) {
          if (history.location.pathname !== '/') {
            if (clickedItem === 'A') {
              clickedItem = '';
            } else {
              sessionStorage.setItem('role', '');
              logOutDispatcher();
              fetchLabelDispatcher();
            }
          }
        }
        if (history.location.pathname === '/schemeselection') {
          val = false;
        }
      }
      return val;
    });

    if (window.performance) {
      if (performance.navigation.type === 1) {
        if (history.location.pathname !== '/') {
          if (
            history.location.pathname !== '/userprereg' &&
            history.location.pathname !== '/sessiontimeout' &&
            history.location.pathname !== '/verifyemail' &&
            history.location.pathname !== '/ca' &&
            history.location.pathname !== '/login' &&
            history.location.pathname !== '/unregisteruserlist'
          ) {
            if (history.location.pathname !== '/') {
              if (clickedItem === 'A') {
                clickedItem = '';
              } else {
                sessionStorage.setItem('role', '');
                logOutDispatcher();
                fetchLabelDispatcher();
              }
            }
          }
        }
      }
    }
  }

  componentDidMount = () => {
    RiskMinder.getMFP();
    window.addEventListener('resize', this.setDeviceConfig);
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.setDeviceConfig);
    if (this.historyListner) {
      this.historyListner = null;
    }
  };

  render() {
    const { store, location, isSecureEnabled, deviceType } = this.props;
    return (
      <Provider store={store}>
        <RouteRenderer
          isSecureEnabled={isSecureEnabled}
          location={location}
          routeConfig={routeConfig}
          store={store}
          deviceType={deviceType}
        />
      </Provider>
    );
  }
}

const mapStateToProps = state => ({
  deviceType: get(state, 'global.globalData.deviceType', ''),
  isSecureEnabled: get(state, 'global.globalData.isAppSecure'),
});

const mapDispatchToProps = dispatch => ({
  onDeviceResizeAction: bindActionCreators(onDeviceResize, dispatch),
  logOutDispatcher: bindActionCreators(logOut, dispatch),
  handleSessionLogoutDispatcher : bindActionCreators(handleSessionLogout, dispatch),
  fetchLabelDispatcher: bindActionCreators(fetchLabelsAction, dispatch),
});

// To initialise the store
export default clientEnhance(App, {
  key: 'app',
  mapStateToProps,
  mapDispatchToProps,
});

